document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section="collection-accordions"]');
  if (!sections.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    section.querySelectorAll('.c-accordion').forEach((accordion) => {
      const trigger = accordion.querySelector('.c-accordion__trigger');
      const panel = accordion.querySelector('.c-accordion__panel');
      const icon = accordion.querySelector('[data-icon]');

      if (!trigger || !panel || !icon) return;

      const setOpenState = () => {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        icon.textContent = '×';
      };

      const setClosedState = () => {
        trigger.setAttribute('aria-expanded', 'false');
        icon.textContent = '+';
        panel.hidden = true;
      };

      const open = () => {
        if (prefersReducedMotion) {
          setOpenState();
          panel.style.height = 'auto';
          return;
        }

        panel.hidden = false;
        panel.style.height = '0px';
        const targetHeight = `${panel.scrollHeight}px`;

        requestAnimationFrame(() => {
          panel.style.height = targetHeight;
        });

        trigger.setAttribute('aria-expanded', 'true');
        icon.textContent = '×';

        const handleOpenTransitionEnd = (event) => {
          if (event.target !== panel) return;
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', handleOpenTransitionEnd);
        };

        panel.addEventListener('transitionend', handleOpenTransitionEnd);
      };

      const close = () => {
        if (prefersReducedMotion) {
          panel.style.height = '';
          setClosedState();
          return;
        }

        const currentHeight = panel.scrollHeight;
        panel.style.height = `${currentHeight}px`;

        requestAnimationFrame(() => {
          panel.style.height = '0px';
        });

        trigger.setAttribute('aria-expanded', 'false');
        icon.textContent = '+';

        const handleCloseTransitionEnd = (event) => {
          if (event.target !== panel) return;
          panel.hidden = true;
          panel.style.height = '';
          panel.removeEventListener('transitionend', handleCloseTransitionEnd);
        };

        panel.addEventListener('transitionend', handleCloseTransitionEnd);
      };

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          close();
        } else {
          open();
        }
      });
    });
  });
});
